import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useContent } from "@/content/ContentContext";
import { useLang } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1];

export default function FittingsPage() {
  const content = useContent();
  const { t } = useLang();
  const fittings = content.fittings || [];

  return (
    <section
      data-testid="fittings-page"
      className="mx-auto max-w-[1440px] px-6 pb-28 pt-32 lg:px-12 lg:pt-40"
    >
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease }}
        className="text-xs uppercase tracking-[0.3em] text-harvest"
      >
        Fittings &amp; Accessories — Har Connection Ka Saaman
      </motion.p>
      <motion.h1
        initial={{ opacity: 0, y: 32 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.1, ease }}
        data-testid="fittings-heading"
        className="mt-6 max-w-3xl font-display text-4xl font-medium leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl"
      >
        Har connection, <span className="italic text-harvest">leak-proof.</span>
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.15, ease }}
        className="mt-6 max-w-xl text-sm leading-relaxed text-sage sm:text-base"
      >
        PVC fittings, PP compression fittings, valves, saddles aur sprinkler/drip
        accessories — poori range ek hi jagah. Har item admin se update hota hai.
      </motion.p>

      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {fittings.map((f, i) => (
          <motion.article
            key={f.id}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease }}
            data-testid={`fitting-card-${f.id}`}
            className="group flex flex-col border border-line bg-moss transition-transform duration-500 hover:-translate-y-1"
          >
            <div className="relative overflow-hidden">
              <img
                src={f.img}
                alt={f.alt || f.name}
                className="h-52 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/25 transition-colors duration-500 group-hover:bg-black/5" />
            </div>
            <div className="flex flex-1 flex-col p-6">
              <h2 className="font-display text-2xl font-medium tracking-tight text-cream">
                {f.name}
              </h2>
              {f.hindi && (
                <p className="mt-1 text-xs uppercase tracking-[0.2em] text-sage">{f.hindi}</p>
              )}
              <p className="mt-3 flex-1 text-sm leading-relaxed text-sage">{f.desc}</p>
              {f.price && (
                <p
                  data-testid={`fitting-price-${f.id}`}
                  className="mt-4 font-display text-2xl font-medium tracking-tight text-harvest"
                >
                  {f.price}
                </p>
              )}
              <Link
                to="/contact"
                data-testid={`fitting-enquire-${f.id}`}
                className="group/btn mt-6 inline-flex w-max items-center gap-2 border border-harvest px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.15em] text-harvest transition-colors duration-300 hover:bg-harvest hover:text-forest"
              >
                {t("enquire")}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover/btn:-translate-y-0.5 group-hover/btn:translate-x-0.5" />
              </Link>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
